export default {"src":"/_next/static/media/ic-live_survey.56f83d56.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};